/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для страницы регистрации и авторизации
   */
  app.AuthView = app.View.extend({
    el: '.b-auth',
    additionalOptions: ['districts', 'isSignUpFormWithName'],

    events: {
      'click #login-js-tab': 'changeHashToLogin',
      'click #signup-js-tab': 'changeHashToSignup',
      'click .auth-link': 'setSocialCookie',
      'mousedown input': app.helpers.DomHelper.preventInputZoom,
    },

    run: function () {
      this.childViews = {};
      this.initializeTabs();
      this.childViews.loginFormView = new app.LoginFormView();
      this.childViews.signupFormView = new app.SignupFormView({
        settlement: this.settlement,
        districts: this.districts,
        withHiddenDistrictField: this.isSignUpFormWithName,
      });
      this.childViews.agreementPopupView = new app.AgreementPopupView({
        el: '[data-popup-id="agreement"]',
        opener: '.link-data-processing-agreement',
      });
    },
    isSignup: false,
    isSignupReady: false,

    /**
     * Метод для инициализации табов
     */
    initializeTabs: function () {
      /* Инициализируем табы */
      var $tabs = this.$('.js-tab');
      this.tabs = new als.Switcher($tabs, this.$('.js-view'));
      this.$s = this.$('.js-selector');

      this.tabs.addEventListener(als.Switcher.EventType.CHANGE, this.toggleLink.bind(this));

      if ($tabs.length) {
        this.$s.css({
          width: $tabs.filter('.selected').width() + 40,
          left: $tabs.filter('.selected').position().left - 20
        });
      }

      this.listenTo(app.authRouter, 'clickSignup', this.clickSignup);
      this.listenTo(app.authRouter, 'clickLogin', this.clickLogin);
    },

    /**
     * Анимация переключения табов
     */
    toggleLink: function () {
      var $current = jQuery(this.tabs.selectedItem_.link_),
        $previos = jQuery(this.tabs.prevSelectedItem_.link_);

      this.$s.animate({
        left: ($current.position().left - 20),
        width: ($current.width() + 40)
      }, 400, 'easeInOutQuint');

      $previos
        .addClass('link link_dark-blue link_pseudo');
      $current
        .removeClass('link link_dark-blue link_pseudo');
    },

    /**
     * Выбор формы авторизации
     */
    clickLogin: function () {
      this.$('#login-js-tab').click();
    },

    /**
     * Выбор формы регистрации
     */
    clickSignup: function () {
      this.$('#signup-js-tab').click();
    },

    /**
     * Изменение хеша на #login
     */
    changeHashToLogin: function () {
      app.authRouter.navigate('login');
    },

    /**
     * Изменение хеша на #signup
     */
    changeHashToSignup: function () {
      app.authRouter.navigate('signup');
    },

    /**
     * Выставление куки для авторизации через соцсети
     */
    setSocialCookie: function () {
      app.helpers.CookieHelper.setCookie('social_auth', window.location.hash, {
        domain: '.' + app.helpers.UrlHelper.getDomain(),
        path: '/',
        expires: 60 //минута
      });
    }

  });
})(jQuery);

}.call(window));